<template>
  <div>
    <InternalNotesWidget
      v-if="user.managerOrHigher"
      entityName="Shift"
      :entityId="shift.id"
      :copyToEmployeeId="shift.userId"
      :copyToLocationId="shift.worksiteId"
    />

    <v-layout
      class="grey lighten-2 pa-2"
      align-content-space-between
      align-center
      row
    >
      <v-flex class="subtle mr-2" shrink>
        <v-icon>assignment_turned_in</v-icon>
      </v-flex>
      <v-flex>
        <h1 class="all-caps subtle">Scheduled Service</h1>
      </v-flex>
    </v-layout>

    <v-layout row my-5>
      <v-flex grow mr-5>
        <ShiftHeader :shift="shift" />
      </v-flex>

      <v-flex shrink mx-5>
        <div class="subtle">
          <p class="body-1">
            <span class="font-weight-bold text-uppercase"
              >Shift Requested By:
            </span>
            <span
              v-if="shift.requesterId > 0 && shift.requesterRole == 'client'"
            >
              <router-link
                target="_blank"
                :to="{ name: 'clientDetail', params: { clientId: shift.requesterId } }"
                >{{ shift.requesterName }}</router-link
              >
            </span>
            <span v-else>
              {{ shift.requesterName }}
            </span>
          </p>
        </div>
        <div v-if="shift.details" class="subtle">
          <p class="body-1">
            <span class="font-weight-bold text-uppercase">Shift Details: </span
            >{{ shift.details }}
          </p>
        </div>
        <div class="subtle">
          <p class="body-1 font-weight-bold">
            <BonusList :shift="shift" :role="user.role" />
          </p>
        </div>
        <v-layout row justify-left>
          <BonusView :shift="shift" type="travel" :role="user.role" />
          <BonusView :shift="shift" type="callIn" :role="user.role" />
          <BonusView :shift="shift" type="straight" :role="user.role" />
        </v-layout>
      </v-flex>

      <v-flex shrink ml-5>
        <div v-if="user.role == 'client'">
          <!-- client deleting -->

          <v-btn v-if="shift.approved" block color="success">
            <v-icon left>visibility</v-icon>
            Published
          </v-btn>

          <v-btn v-else block color="warning">
            <v-icon left>visibility_off</v-icon>
            Not yet Published
          </v-btn>

          <div v-if="!shift.userId">
            <v-dialog v-model="deleteConfirmDialog" full-width max-width="400">
              <v-btn slot="activator" block color="error">
                <v-icon left>
                  cancel
                </v-icon>
                Delete
              </v-btn>
              <v-card>
                <v-card-text class="text-xs-center">
                  <h2 class="headline">Are you sure?</h2>
                  <div class="mb-1">
                    <v-btn
                      block
                      color="error"
                      @click="deleteShift(false, false)"
                    >
                      Yes, Delete it
                    </v-btn>
                  </div>
                </v-card-text>
              </v-card>
            </v-dialog>
          </div>
        </div>

        <div v-if="user.role == 'employee'">
          <!-- employee pick up / trade / location -->
          <div v-if="this.$moment(shift.startDatetime).isAfter()">
            <div v-if="shift.pickupable && user.role == 'employee'">
              <v-dialog
                :disabled="restricted"
                v-model="pickUpDialog"
                max-width="290"
              >
                <v-btn :disabled="restricted" slot="activator" color="success">
                  <v-icon left v-if="restricted">
                    remove_circle
                  </v-icon>
                  <v-icon v-else left>
                    add
                  </v-icon>
                  {{ restricted ? 'Too Close to your other shifts' : 'Pick Up'
                  }}
                </v-btn>
                <v-card>
                  <v-card-title class="headline">Pick Up Shift?</v-card-title>
                  <v-card-text>
                    {{ shift.shiftRole }} at {{ shift.location }} on {{
                    shift.startDatetime | moment("dddd, MMM Do [at] h:mma") }}
                    <ul>
                      <li v-if="shift.hasTravelBonus">
                        {{ shift.travelBonusAmount }} travel bonus
                      </li>
                      <li v-if="shift.hasCallInBonus">
                        {{ shift.callInBonusAmount }} call-in bonus
                      </li>
                      <li v-if="shift.hasStraightBonus">
                        {{ shift.straightBonusAmount }} straight bonus
                      </li>
                    </ul>
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="grey" flat @click="pickUpDialog = false"
                      >Nevermind</v-btn
                    >
                    <v-btn
                      color="success"
                      small
                      :loading="apiCallPending"
                      @click="pickUp"
                    >
                      Yes, I'll take it!
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </div>

            <div v-if="shift.userId === user.id">
              <v-btn
                block
                v-if="!shift.tradePending"
                disabled
                class=""
                color="success"
              >
                Picked up!
              </v-btn>
              <v-btn
                block
                v-if="shift.tradePending && !shift.tradeApprovalPending"
                color="primary"
              >
                <v-icon left>
                  sync
                </v-icon>
                On trade offer...
              </v-btn>
              <v-btn block v-if="shift.tradeApprovalPending" color="warning">
                Trade Pending Manager Approval
              </v-btn>
            </div>

            <div v-if="shift.userId && shift.userId != user.id">
              <v-btn
                block
                v-if="!shift.tradePending"
                disabled
                class=""
                color="success"
              >
                Already Claimed
              </v-btn>
              <v-btn block v-if="shift.tradeApprovalPending" color="warning">
                Trade Pending Manager Approval
              </v-btn>
              <v-dialog
                v-if="shift.tradePending && !shift.tradeApprovalPending"
                v-model="tradeDialog"
                max-width="290"
              >
                <v-btn block slot="activator" color="success">
                  <v-icon left>
                    add
                  </v-icon>
                  Pick Up via Trade
                </v-btn>
                <v-card>
                  <v-card-title class="headline">Trade Shift?</v-card-title>
                  <v-card-text>
                    <p>
                      {{ shift.workerName }} Offered this shift up for trade. If
                      you take this trade, your manager will need to approve it
                      first.
                    </p>
                    {{ shift.shiftRole }} at {{ shift.location }} on {{
                    shift.startDatetime | moment("dddd, MMM Do [at] h:mma") }}
                    <ul>
                      <li v-if="shift.hasTravelBonus">
                        {{ shift.travelBonusAmount }} travel bonus
                      </li>
                      <li v-if="shift.hasCallInBonus">
                        {{ shift.callInBonusAmount }} call-in bonus
                      </li>
                      <li v-if="shift.hasStraightBonus">
                        {{ shift.straightBonusAmount }} straight bonus
                      </li>
                    </ul>
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="grey" flat @click="tradeDialog = false"
                      >Nevermind</v-btn
                    >
                    <v-btn
                      color="success"
                      small
                      :loading="apiCallPending"
                      @click="trade"
                    >
                      Yes, I'll take it!
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </div>
          </div>

          <v-dialog
            v-if="shift.locationMapEmbed"
            full-width
            v-model="mapDialog"
          >
            <v-btn
              block
              slot="activator"
              class="white--text"
              color="grey darken-2"
            >
              <v-icon left>
                location_on
              </v-icon>
              Location
            </v-btn>
            <v-card class="text-xs-center">
              <v-card-text>
                <div v-html="shift.locationMapEmbed"></div>
              </v-card-text>
            </v-card>
          </v-dialog>
        </div>
        <div v-if="user.managerOrHigher">
          <ManagerCancelShiftButton v-if="shift" :shift="shift" />

          <div v-if="!shift.approved">
            <!-- manager publishing -->
            <div v-if="shift.repeats">
              <v-dialog v-model="publishDialog" full-width max-width="400">
                <v-btn slot="activator" block color="success">
                  <v-icon left>
                    thumb_up
                  </v-icon>
                  Publish
                </v-btn>

                <v-card>
                  <v-card-text class="text-xs-center">
                    <h2 class="headline">This shift is part of a series</h2>
                    <div class="mb-1">
                      <v-btn
                        block
                        color="success"
                        @click="approveShift(false, false)"
                      >
                        Publish only this shift
                      </v-btn>
                    </div>
                    <div class="mb-1">
                      <v-btn
                        block
                        color="success"
                        @click="approveShift(false, true)"
                      >
                        Publish this and following shifts
                      </v-btn>
                    </div>
                    <div class="mb-1">
                      <v-btn
                        block
                        color="success"
                        @click="approveShift(true, false)"
                      >
                        Publish all shifts in this series
                      </v-btn>
                    </div>
                  </v-card-text>
                </v-card>
              </v-dialog>
            </div>
            <div v-else>
              <v-btn block color="success" @click="approveShift(false, false)">
                <v-icon left>
                  thumb_up
                </v-icon>
                Publish
              </v-btn>
            </div>
          </div>
          <div v-else>
            <div v-if="shift.repeats">
              <v-dialog v-model="unpublishDialog" full-width max-width="400">
                <v-btn slot="activator" block color="error">
                  <v-icon left>
                    remove_circle
                  </v-icon>
                  Unpublish
                </v-btn>

                <v-card>
                  <v-card-text class="text-xs-center">
                    <h2 class="headline">This shift is part of a series</h2>
                    <div class="mb-1">
                      <v-btn
                        block
                        color="error"
                        @click="disapproveShift(false, false)"
                      >
                        Unpublish only this shift
                      </v-btn>
                    </div>
                    <div class="mb-1">
                      <v-btn
                        block
                        color="error"
                        @click="disapproveShift(false, true)"
                      >
                        Unpublish this and following shifts
                      </v-btn>
                    </div>
                    <div class="mb-1">
                      <v-btn
                        block
                        color="error"
                        @click="disapproveShift(true, false)"
                      >
                        Unpublish all shifts in this series
                      </v-btn>
                    </div>
                  </v-card-text>
                </v-card>
              </v-dialog>
            </div>
            <div v-else>
              <v-btn block color="error" @click="disapproveShift(false, false)">
                <v-icon left>
                  remove_circle
                </v-icon>
                Unpublish
              </v-btn>
            </div>
          </div>
          <div v-if="shift.repeats">
            <!-- manager deleting -->
            <v-dialog v-model="deleteDialog" full-width max-width="400">
              <v-btn slot="activator" block color="error">
                <v-icon left>
                  cancel
                </v-icon>
                Delete
              </v-btn>

              <v-card>
                <v-card-text class="text-xs-center">
                  <h2 class="headline">This shift is part of a series</h2>
                  <div class="mb-1">
                    <v-btn
                      block
                      color="error"
                      @click="deleteShift(false, false)"
                    >
                      Delete only this shift
                    </v-btn>
                  </div>
                  <div class="mb-1">
                    <v-btn
                      block
                      color="error"
                      @click="deleteShift(false, true)"
                    >
                      Delete this and following shifts
                    </v-btn>
                  </div>
                  <div class="mb-1">
                    <v-btn
                      block
                      color="error"
                      @click="deleteShift(true, false)"
                    >
                      Delete all shifts in this series
                    </v-btn>
                  </div>
                </v-card-text>
              </v-card>
            </v-dialog>
          </div>

          <div v-else>
            <v-dialog v-model="deleteConfirmDialog" full-width max-width="400">
              <v-btn slot="activator" block color="error">
                <v-icon left>
                  cancel
                </v-icon>
                Delete
              </v-btn>
              <v-card>
                <v-card-text class="text-xs-center">
                  <h2 class="headline">Are you sure?</h2>
                  <div class="mb-1">
                    <v-btn
                      block
                      color="error"
                      @click="deleteShift(false, false)"
                    >
                      Yes, Delete it
                    </v-btn>
                  </div>
                </v-card-text>
              </v-card>
            </v-dialog>
          </div>
        </div>
      </v-flex>
    </v-layout>

    <v-layout row>
      <!-- small bar -->
      <v-toolbar color="primary" flat dense class="hidden-md-and-up">
        <v-menu>
          <template v-slot:activator="{ on }">
            <v-toolbar-title v-on="on">
              <span class='white--text'>
                {{ componentNameReadable }}
                <v-icon color="white">arrow_drop_down</v-icon>
              </span>
            </v-toolbar-title>
          </template>
          <v-list>
            <v-list-tile
              v-for="item in tabOptions" :key="`${ item.routeName }-1`"
              :to="{ name: item.routeName }"
              v-if="showNavOptions(item)"
              :disabled="navDisabled(item)"
            >
              <v-list-tile-title v-text="item.linkLabel"></v-list-tile-title>
            </v-list-tile>
          </v-list>
        </v-menu>
      </v-toolbar>

      <!-- large bar -->
      <v-toolbar color="primary" flat dense class="hidden-sm-and-down"  style="overflow-x: auto;">
        <v-toolbar-items v-for="item in tabOptions" :key="`${ item.routeName }-1`" v-if="showNavOptions(item)">
          <v-btn
            small
            flat
            color="white"
            :to="{ name: item.routeName }"
            exact
            :disabled="navDisabled(item)"
          >
            {{ item.linkLabel }}
          </v-btn>
        </v-toolbar-items>
      </v-toolbar>
    </v-layout>

    <v-layout row>
      <component
        :is="componentName"
        v-bind="{ shift, user, versions: shift.versions, employee: true, client: true }"
      ></component>
    </v-layout>

  </div>
</template>

<script>
  import {mapState, mapGetters} from 'vuex';
  import ApiField from '@/components/base/api-field.vue';
  import PunchRow from '@/components/calendar/punch.vue';
  import ShiftHeader from '@/components/calendar/shift-header.vue';
  import ShiftChangeHistory from '@/components/calendar/shift-change-history.vue';
  import ShiftReview from '@/components/calendar/shift-review.vue';
  import ShiftContact from '@/components/calendar/shift-contact.vue';
  import ManagerCancelShiftButton from '@/components/calendar/manager-cancel-shift-button.vue';
  import SARNotes from '@/components/calendar/sar-notes.vue';
  import shiftApi from '@/api/shift';
  import TradeRequest from '@/components/calendar/manager-tabs/trade-request.vue';
  import Detail from '@/components/calendar/manager-tabs/detail.vue';
  import WorkHistory from '@/components/calendar/manager-tabs/history.vue';

  export default {
    props: ['user', 'shift'],
    components: {
      ApiField,
      PunchRow,
      ShiftHeader,
      ShiftChangeHistory,
      ShiftReview,
      ShiftContact,
      ManagerCancelShiftButton,
      SARNotes,

      TradeRequest,
      Detail,
      WorkHistory,
    },
    created() {
      this.setUp();
    },
    watch: {},
    computed: {
      ...mapState('shifts', ['notes']),
      ...mapState('serviceRequest', ['assignableEmployees']),
      ...mapGetters('timeclock', ['sortedPunches']),
      reviewable() {
        return this.$moment(this.shift.startDatetime).isBefore(this.$moment());
      },

      componentName() {
        const currentComponent = this.tabOptions.find((o) => {
          return o.routeName === this.$router.currentRoute.name
        })

        if (!currentComponent) {
          this.$router.push({ name: 'shift/detail' })
          return 'Detail'
        }

        return currentComponent.componentName
      },
      componentNameReadable() {
        const currentComponent = this.tabOptions.find((o) => {
          return o.routeName === this.$router.currentRoute.name
        })

        if (!currentComponent) {
          this.$router.push({ name: 'shift/detail' })
          return 'Detail'
        }

        return currentComponent.linkLabel
      }
    },
    data: function() {
      return {
        pickUpDialog: false,
        tradeDialog: false,
        apiCallPending: false,
        tradeReason: null,
        mapDialog: false,
        deleteDialog: false,
        deleteConfirmDialog: false,
        publishDialog: false,
        unpublishDialog: false,
        newNote: '',
        restricted: true,

        tabOptions: [
          {
            routeName: "shift/detail",
            linkLabel: "Detail",
            componentName: 'Detail'
          },
          {
            routeName: "shift/work-history",
            linkLabel: "Work History",
            componentName: 'WorkHistory',
          },
          {
            routeName: "shift/record-history",
            linkLabel: "Record History",
            componentName: 'ShiftChangeHistory',
          },
          {
            routeName: "shift/contact",
            linkLabel: "Contact",
            componentName: 'ShiftContact',
          },
          {
            routeName: "shift/shift-review",
            linkLabel: "Shift Review",
            componentName: 'ShiftReview',
          },
          {
            routeName: "shift/sar",
            linkLabel: "SAR",
            componentName: 'SARNotes',
          },
          {
            routeName: "shift/trade-request",
            linkLabel: "Trade Request",
            componentName: 'TradeRequest',
          },
        ]
      };
    },
    methods: {
      setUp() {
        this.$store.dispatch('timeclock/getPunches', {shiftId: this.shift.id});
        this.$store.dispatch('shifts/getNotes', {shiftId: this.shift.id});
        this.$store.dispatch('serviceRequest/getOptions', this.user.id);
      },
      deleteShift(allRecurring, onlyAfter) {
        this.$store
          .dispatch('shifts/destroy', {
            shiftId: this.shift.id,
            allRecurring: allRecurring,
            onlyAfter: onlyAfter,
          })
          .finally(res => {
            this.$router.push('/calendar/list');
          });
      },
      approveShift(allRecurring, onlyAfter) {
        this.$store
          .dispatch('shifts/approve', {
            shiftId: this.shift.id,
            allRecurring: allRecurring,
            onlyAfter: onlyAfter,
          })
          .finally(res => {
            this.$store.dispatch('shifts/getShift', this.shift.id);
          });
      },
      disapproveShift(allRecurring, onlyAfter) {
        this.$store
          .dispatch('shifts/disapprove', {
            shiftId: this.shift.id,
            allRecurring: allRecurring,
            onlyAfter: onlyAfter,
          })
          .finally(res => {
            this.$store.dispatch('shifts/getShift', this.shift.id);
          });
      },

      navDisabled(item) {
        return item.componentName === 'ShiftReview' && !this.reviewable
      },

      showNavOptions(item) {
        if (item.componentName === 'TradeRequest' && !this.shift.tradePending) {
          return false
        }
        return true
      },

    },
  };
</script>
